export default {

    apiUrl: 'https://www.selfpetitionusa.com/api'

}
